// Reine, testbare Gruppierung der Serverdaten in Terminal-Bereiche.
// Bildet KEINE Businessregel nach — leitet nur eine Anzeigekategorie aus
// dem vom Server gelieferten status/prep_status ab.
import type { TerminalOrder } from "./types";

export type OrderBucket = "decision" | "preparing" | "ready" | "in_delivery" | "done";

export function bucketOf(o: TerminalOrder): OrderBucket {
  switch (o.status) {
    case "awaiting_merchant":
      return "decision";
    case "handed_over":
    case "not_collected":
    case "cancelled":
    case "merchant_rejected":
      return "done";
    case "merchant_accepted":
    case "awaiting_assignment":
    case "rider_assigned":
    case "rider_accepted":
    case "en_route_to_shop":
    case "at_shop":
      // Nach Annahme, vor Abholung: Zubereitung vs. bereit.
      return o.prep_status === "ready" ? "ready" : "preparing";
    case "picked_up":
    case "en_route_to_point":
    case "at_point":
    case "incident":
      return "in_delivery";
    default:
      return "done";
  }
}

export interface GroupedOrders {
  decision: TerminalOrder[];
  preparing: TerminalOrder[];
  ready: TerminalOrder[];
  in_delivery: TerminalOrder[];
  done: TerminalOrder[];
}

export function groupOrders(orders: TerminalOrder[]): GroupedOrders {
  const g: GroupedOrders = { decision: [], preparing: [], ready: [], in_delivery: [], done: [] };
  for (const o of orders) g[bucketOf(o)].push(o);
  return g;
}

/** Kann der Händler „Zubereitung starten" anbieten? (accepted, noch none) */
export function canStartPreparing(o: TerminalOrder): boolean {
  return bucketOf(o) === "preparing" && o.prep_status === "none";
}

/** Kann der Händler „Bereit" melden? (in Zubereitung, noch nicht ready) */
export function canMarkReady(o: TerminalOrder): boolean {
  return o.prep_status === "preparing";
}
